import { AuditExplorer } from "../audit/AuditExplorer";

export function AuditView() {
  return <AuditExplorer audience="operations" />;
}
